import { LockIcon } from '@maersktankersdigital/web-components'
import { Box, Typography } from '@mui/material'
import { IQuestionnaireField } from '~api/vessels/read'
import { COLORS } from '~theme/colors'

export function NameDescriptionDetails({
  name,
  description,
  details,
  readOnly,
}: IQuestionnaireField) {
  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        {name && (
          <Typography variant="label" component="p">
            {name}
          </Typography>
        )}
        {readOnly && <LockIcon color={COLORS.red.dark} />}
      </Box>
      {description && (
        <Typography variant="caption" component="p">
          {description}
        </Typography>
      )}
      {details && typeof details === 'string' && (
        <Typography
          variant="caption"
          component="article"
          dangerouslySetInnerHTML={{ __html: details }}
        />
      )}
    </Box>
  )
}
